import { useState, useEffect } from 'react';
import styles from '../styles/Carousel.module.css';

export default function Carousel({ images, interval = 5000 }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  const goTo = (i) => setCurrent(i);
  const prev = () => setCurrent((c) => (c - 1 + images.length) % images.length);
  const next = () => setCurrent((c) => (c + 1) % images.length);

  return (
    <div className={styles.carousel}>
      <div className={styles.slides}>
        {images.map((img, i) => (
          <div
            key={i}
            className={`${styles.slide} ${i === current ? styles.active : ''}`}
            style={{ backgroundImage: `url(${img.src})` }}
          >
            {img.caption && (
              <div className={styles.caption}>
                <h3>{img.caption}</h3>
                {img.subtitle && <p>{img.subtitle}</p>}
              </div>
            )}
          </div>
        ))}
      </div>

      <button className={`${styles.navBtn} ${styles.prev}`} onClick={prev} aria-label="Anterior">
        ‹
      </button>
      <button className={`${styles.navBtn} ${styles.next}`} onClick={next} aria-label="Siguiente">
        ›
      </button>

      <div className={styles.dots}>
        {images.map((_, i) => (
          <button
            key={i}
            className={`${styles.dot} ${i === current ? styles.activeDot : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Ir a imagen ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
